class VariantSelects extends HTMLElement {
constructor() {
  super();

  this.variant =
    this.variant ??
    JSON.parse(
      this.querySelector('variant-selects [data-selected-variant]')
        ?.innerHTML
    );

  // SUPPORT BOTH EN + AR FIELDSET NAMES
  this.sizeOptions = [
    ...this.querySelectorAll('fieldset[data-name="Size"] label'),
    ...this.querySelectorAll('fieldset[data-name="مقاس"] label')
  ];

  this.colorOptions = [
    ...this.querySelectorAll('fieldset[data-name="Color"] label'),
    ...this.querySelectorAll('fieldset[data-name="لون"] label')
  ];

  this.genderOptions = [
    ...this.querySelectorAll('fieldset[data-name="Gender"] label'),
    ...this.querySelectorAll('fieldset[data-name="جنس"] label')
  ];
}

  connectedCallback() {
    const section = this.closest('section');
    const productInfo = this.closest('product-info');
    const selectBtn = productInfo?.querySelector('.btn-select-size');
    const sizePopup = productInfo?.querySelector('.size-secection');
    const closeBtn = productInfo?.querySelector('.close-size');

    // Restore last-picked size
    if (window.sizeSelected) {
      console.log(window.sizeSelected,"window.sizeSelected")
      //const field = this.querySelector(`fieldset[data-name="Size"] input[value="${window.sizeSelected}"]`);
      const field = this.querySelector(
  `fieldset[data-name="Size"] input[value="${window.sizeSelected}"], 
   fieldset[data-name="مقاس"] input[value="${window.sizeSelected}"]`
);
      if (field) field.checked = true;
    }

    // Clone blocks for mobile
    this.linkedTo = [...productInfo.querySelectorAll('[data-linked-to]')];
    this.linkedTo.forEach(block => {
      const toClone = this.querySelector(`fieldset[data-name="${block.dataset.linkedTo}"]`).cloneNode(true);
      const name = block.dataset.linkedTo.toLowerCase();
      this[`${name}Options`] = [
        ...(this[`${name}Options`] || []),
        ...toClone.querySelectorAll('label')
      ];
      toClone.querySelectorAll('[id]').forEach(el => {
        el.id += 'cloned';
        el.name += 'cloned';
      });
      block.innerHTML = '';
      [...toClone.childNodes].reverse().forEach(n => toClone.append(n));
      block.appendChild(toClone);
    });

    // Filter options and show section
    if (!this.dataset.combined) this.filterOptions();
    this.loader = productInfo.querySelector('.loader');
    if (!section.classList.contains('show')) {
      section.classList.add('show');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    this.removeLoader();

    // Update size label if already selected
    if (window.sizeSelected && selectBtn) {
      selectBtn.textContent = window.sizeSelected;
      selectBtn.classList.add('selected');
    }

    // Size popup toggle
    if (selectBtn && !selectBtn.classList.contains('bound')) {
      selectBtn.addEventListener('click', () => {
        sizePopup.style.display = 'block';
      });
      selectBtn.classList.add('bound');
    }
    if (closeBtn && !closeBtn.classList.contains('bound')) {
      closeBtn.addEventListener('click', () => {
        sizePopup.style.display = 'none';
      });
      closeBtn.classList.add('bound');
    }

    this.addEventListener('change', event => {
      const t = this.getInputForEventTarget(event.target);
      const fs = t.closest('fieldset');
      const name = fs?.dataset.name;

      if (name === 'Gender') {
        window.sizeSelected = '';
        this.querySelectorAll('fieldset[data-name="Size"] input[type="radio"]').forEach(r => r.checked = false);
        if (selectBtn) {
          selectBtn.textContent = 'Select a size';
          selectBtn.classList.remove('selected');
        }
        sizePopup.style.display = 'none';
        section.classList.remove('show');
        this.showLoader();
      }

      if (name === 'Color') {
        section.classList.remove('show');
      }

      if (name === 'Size' || name === 'مقاس') {
          console.log('test1')
          
          // Check if the selected size is NOT disabled
          if (!t.classList.contains("disabled")) {
            window.sizeSelected = t.value;
            console.log('test123',t.value)
            
            if (selectBtn) {
              console.log('test123444');
              selectBtn.textContent = t.value;
              selectBtn.classList.add('selected');
            }
            sizePopup.style.display = 'none';

          } else {
            // Only show 'Select a size' if the selected option IS disabled
            // and clear the selection
            window.sizeSelected = '';
            if (selectBtn) {
            selectBtn.textContent = 'Select a size123';
            selectBtn.classList.remove('selected');
            }
          }
          
          // Loader/Notification logic only executes if the size is disabled
          if (t.classList.contains("disabled")) {
            document.body.classList.add("loader-active");
            waitForElementAndClick(".gw-button-widget, .gw-float-widget");
          }
      }
    function waitForElementAndClick(selector, maxAttempts = 10, interval = 200) {
        let attempts = 0;

        const checkAndClick = () => {
        const element = document.querySelector(selector);

        if (element && typeof element.click === 'function') {
        try {
        console.log("Button found, attempting to click.");
        element.click();
        document.body.classList.remove("loader-active");
        return true; // Success
        } catch (error) {
        console.warn("Click failed, retrying...", error);
        }
        }

        // If not successful and we have more attempts, try again
        if (attempts < maxAttempts) {
        attempts++;
        setTimeout(checkAndClick, interval);
        } else {
        console.error("Failed to find or click the element after maximum attempts.");
        }
        };

        checkAndClick();
    }

      this.updateSelectionMetadata(event);
      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target: t,
          selectedOptionValues: this.selectedOptionValues,
          selectedOptions: this.selectedOptions,
        }
      });

      this.applyFallback();
    });

    // Observer for stock fallback
    const desktopBtn = productInfo.querySelector('button.product-form__submit');
    if (desktopBtn) new MutationObserver(() => {
      const { Gender: g, Color: c } = this.selectedOptions;
      const inStock = (window.ShopifyProduct?.variants || []).filter(v => v.options[0] === g && v.options[1] === c && v.available);
      if (inStock.length > 0 && desktopBtn.disabled) this.applyFallback();
    }).observe(desktopBtn, { attributes: true, childList: true, subtree: true });

    document.querySelectorAll('form.add-to-cart-form button').forEach(btn => {
      new MutationObserver(() => {
        const { Gender: g, Color: c } = this.selectedOptions;
        const inStock = (window.ShopifyProduct?.variants || []).filter(v => v.options[0] === g && v.options[1] === c && v.available);
        if (inStock.length > 0 && btn.disabled) this.applyFallback();
      }).observe(btn, { attributes: true, childList: true, subtree: true });
    });
  }

filterOptions = (hide = true) => {
  const g = this.selectedOptions["Gender"] || this.selectedOptions["جنس"];
  const c = this.selectedOptions["Color"]  || this.selectedOptions["لون"];

  // All variants for selected Gender
  const variantsByGender = ShopifyProduct.variants.filter(v => v.options[0] === g);

  // Colors available for this gender
  const genderColors = [...new Set(variantsByGender.map(v => v.options[1]))];

  // Hide ALL color labels that are NOT for this gender
  this.colorOptions.forEach(el => {
    el.hidden = !genderColors.includes(el.dataset.value);
  });

  // Sizes available EXCLUSIVELY for selected gender + selected color
  const variantsByGenderColor = variantsByGender.filter(v => v.options[1] === c);
  const sizes = [...new Set(variantsByGenderColor.map(v => v.options[2]))];

  // Hide irrelevant sizes
  this.sizeOptions.forEach(el => {
    el.hidden = !sizes.includes(el.dataset.value);
  });

  return true;
};

  applyFallback() {
    const variants = window.ShopifyProduct?.variants || [];
    const { Gender: g, Color: c } = this.selectedOptions;
    if (!g || !c) return;

    const inStock = variants.filter(v => v.options[0] === g && v.options[1] === c && v.available);
    const fallback = inStock[0] || null;

    const root = this.closest('product-info');
    if(root){
      const desktopInput = root.querySelector('input.product-variant-id');
      const desktopBtn = root.querySelector('button.product-form__submit');
      if (desktopInput && desktopBtn) {
      if (fallback) {
        desktopInput.value = fallback.id;
        desktopInput.disabled = false;
        desktopBtn.disabled = false;
        desktopBtn.querySelector('span').textContent = 'Add to bag';
      } else {
        desktopInput.value = '';
        desktopInput.disabled = true;
        desktopBtn.disabled = true;
        desktopBtn.querySelector('span').textContent = 'Sold out';
      }
    }
    }

    

    document.querySelectorAll('form.add-to-cart-form').forEach(form => {
      const input = form.querySelector('input.product-variant-id');
      const btn = form.querySelector('button');
      if (!input || !btn) return;
      if (fallback) {
        input.value = fallback.id;
        input.disabled = false;
        btn.disabled = false;
        btn.textContent = 'Add to bag';
      } else {
        input.value = '';
        input.disabled = true;
        btn.disabled = true;
        btn.textContent = 'Sold out';
      }
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;
    if (tagName === 'SELECT' && target.selectedOptions.length) {
      target.querySelectorAll('option').forEach(o => o.selected = false);
      target.selectedOptions[0].selected = true;
      const sw = target.closest('.product-form__input').querySelector('[data-selected-value]>.swatch');
      const v = target.selectedOptions[0].dataset.optionSwatchValue;
      if (sw) {
        sw.style.setProperty('--swatch--background', v || 'unset');
        sw.classList.toggle('swatch--unavailable', !v);
      }
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const disp = target.closest('.product-form__input')?.querySelector('[data-selected-value]');
      if (disp) disp.textContent = value;
    }
  }

  showLoader() {
    this.loader?.classList.add('active');
  }

  removeLoader() {
    this.loader?.classList.remove('active');
  }

  getInputForEventTarget(t) {
    return t.tagName === 'SELECT' ? t.selectedOptions[0] : t;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option:checked, fieldset input:checked')).map(el => el.dataset.optionValueId);
  }

  get selectedOptions() {
    return Array.from(this.querySelectorAll('select option:checked, fieldset input:checked')).reduce((a, el) => {
      a[el.closest('fieldset').dataset.name] = el.value;
      return a;
    }, {});
  }
}

customElements.define('variant-selects', VariantSelects);
